import { BusinessDataUi } from '@/components/Buyer/BuyerProfile/Account/BusinessData/BusinessDataUi';
import { ContactDataUi } from '@/components/Buyer/BuyerProfile/Account/ContactData/ContactDataUi';
import { BuyerContactDataResponse } from '@/data/api/model/buyers/BuyersDto';

export function buyerContactDataResponseToContactDataUi(
  input: BuyerContactDataResponse
): ContactDataUi {
  return {
    fullName: input.full_name,
    phone: input.phone,
    email: input.email,
    cancelDisabled: true,
    saveDisabled: true,
  };
}

export function buyerContactDataResponseToBusinessDataUi(
  input: BuyerContactDataResponse
): BusinessDataUi {
  return {
    businessName: input.name,
    cancelDisabled: true,
    saveDisabled: true,
  };
}
